export default __webpack_public_path__ + "assets/images/c8c803cc998cdd9ed9b3f92515872050.svg";